import React from 'react';
// import sections
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Testimonial from '../components/sections/Testimonial';
import Cta from '../components/sections/Cta';

const Home = () => {

  return (
    <>
      <Header navPosition="right" className="reveal-from-bottom" />
      <Hero className="illustration-section-01" />
      <FeaturesTiles className="Area" />
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02 Atuacao" />
      <Testimonial topDivider className="Casos" />
      <Cta split />
      <Footer />
    </>
  );
}

export default Home;
